import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';
import {CampaignSetupAgentToolName} from '../../campaignSetupAgent.enums';
import {productCardSchema} from '../../schemas/productCardSchema';
import addOrUpdateCardTool from '../general/addOrUpdateCardTool/addOrUpdateCardTool';
import getProductFeedColumnsTool from './getProductFeedColumnsTool';
import getProductMatchingSignalTool from './getProductMatchingSignalTool';
import matchStrategyTool from '../strategy/matchStrategyTool';
import searchObjectsTool from '../general/searchObjectsTool/searchObjectsTool';

export default function addOrUpdateProductCardTool(store: CLStore) {
  return addOrUpdateCardTool({
    store,
    cardType: NodeType.PRODUCTS,
    cardSchema: productCardSchema,
    description: 'Add or update SINGLE Products card. Can search for product feeds by prompt.',
    tools: [
      getProductMatchingSignalTool(store),
      getProductFeedColumnsTool(),
      matchStrategyTool(store),
      searchObjectsTool(store),
    ],
    cardSpecificInstructions: `1. YOU MUST ALWAYS Use the ${CampaignSetupAgentToolName.MatchStrategy} tool to find the best product selection strategy, following the user's request.
2. When dealing with custom matching or condition based strategy: 
2.1. use the ${CampaignSetupAgentToolName.GetProductMatchingSignal} tool to find the best matching signal following user's request.
2.2. use the ${CampaignSetupAgentToolName.GetProductFeedColumns} tool to find the best matching feed column following user's request.`,
  });
}
